import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Zigzag · Text + Media (bskr/layout-zigzag-text-media) entrance. Global partial
// — the layout nests inside pages where per-block scripts aren't reliably
// enqueued. The block is a 2×2 grid (text ↖, asset ↗, asset ↙, text ↘); we fade
// its four segments in just once, in visual zigzag order (top row L→R, then the
// bottom row), when the block scrolls into view.
//
// Editor: skipped (wp.data only exists in Gutenberg). Reduced motion: segments
// are shown immediately, no animation. Hiding is JS-only, so the block degrades
// gracefully (stays visible) if the script never runs. ScrollTrigger is synced
// with Lenis in main.js.

function start() {
  if (typeof window !== "undefined" && window.wp && window.wp.data) return;
  init();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}

// The four segments in visual zigzag order. Each Bootstrap column holds two
// segments (a text group + a responsive asset); interleaving the columns
// row-by-row yields top-left, top-right, bottom-left, bottom-right.
function orderedSegments(root) {
  const SEL =
    ":scope > .bskr-zigzag-text-media__text, :scope > .bskr-responsive-asset";
  const row = root.querySelector(".wp-bootstrap-blocks-row");
  const cols = row ? Array.from(row.children) : [];
  const colSegs = cols.map((col) => Array.from(col.querySelectorAll(SEL)));

  const ordered = [];
  const rows = Math.max(0, ...colSegs.map((s) => s.length));
  for (let r = 0; r < rows; r++) {
    for (const segs of colSegs) {
      if (segs[r]) ordered.push(segs[r]);
    }
  }

  // Fallback: whatever segments exist, in DOM order.
  if (!ordered.length) {
    return Array.from(
      root.querySelectorAll(
        ".bskr-zigzag-text-media__text, .bskr-responsive-asset"
      )
    );
  }
  return ordered;
}

function init() {
  const roots = document.querySelectorAll(
    ".wp-block-bskr-layout-zigzag-text-media"
  );
  if (!roots.length) return;

  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  roots.forEach((root) => {
    if (root.dataset.zigzagInited === "1") return;
    root.dataset.zigzagInited = "1";

    const segments = orderedSegments(root);
    if (!segments.length) return;

    // Reduced motion, or nested inside a Content Slider slide: show the segments
    // immediately, no ScrollTrigger. Inside a horizontally-translated Swiper the
    // vertical scroll trigger never fires correctly and would leave the content
    // stuck at autoAlpha:0 (see content-slider.js — slides carry
    // `data-no-scroll-reveal`).
    if (reduce || root.closest("[data-no-scroll-reveal]")) {
      gsap.set(segments, { autoAlpha: 1, y: 0 });
      return;
    }

    gsap.set(segments, { autoAlpha: 0, y: 28 });

    gsap.to(segments, {
      autoAlpha: 1,
      y: 0,
      duration: 0.7,
      ease: "power2.out",
      stagger: 0.18,
      scrollTrigger: {
        trigger: root,
        start: "top 75%",
        once: true,
      },
    });
  });
}
